import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'

// Hand-written until the OpenAPI types are regenerated.
export type EndingLeaseState = 'EXTEND' | 'NOT_EXTEND' | 'NO_ANSWER' | 'NOTICE'

export type LeaseReminderStatus =
  | 'SENT'
  | 'PENDING'
  | 'SKIPPED'
  | 'FAILED'
  | 'CANCELED'
  | 'UPCOMING'
  | 'MISSED'
  | 'SUPERSEDED'

export interface LeaseReminder {
  days: number
  status: LeaseReminderStatus
  sent_at: string | null
  reason: '' | 'ANSWERED' | 'NOTICE' | 'OTHER'
}

export interface EndingLease {
  contract_id: string
  contract_number: string
  offer_id: string
  flat_title: string
  flat_address: string
  tenant_name: string
  tenant_email: string
  end_date: string
  days_left: number
  state: EndingLeaseState
  renewal_note: string
  renewal_answered_at: string | null
  reminders: LeaseReminder[]
  manual_reminder: { status: string; sent_at: string | null } | null
  /** What the send button sends next; null = nothing left to send. */
  next_reminder: '75' | '45' | 'MANUAL' | null
}

export interface EndingLeases {
  total: number
  extend: number
  not_extend: number
  no_answer: number
  notice: number
  missed: number
  leases: EndingLease[]
}

export const endingLeasesQueryKey = ['dashboard-ending-leases']

export function useEndingLeases() {
  async function getEndingLeases(): Promise<EndingLeases> {
    const response = await apiClient.get<EndingLeases>(
      SNA_PREFIX + 'dashboard/ending-leases'
    )
    return response.data
  }

  return useQuery({
    queryFn: getEndingLeases,
    queryKey: endingLeasesQueryKey
  })
}
